import * as types from '../constants/actionTypes';
import { CALL_API } from '../helpers/api';

export const actions = {
    search: (searchParams) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'location-contact/search',
                    method: 'POST',
                    body: searchParams,
                    types: [
                        types.SEARCH_LOCATION_CONTACTS_REQUEST,
                        types.SEARCH_LOCATION_CONTACTS_SUCCESS,
                        types.SEARCH_LOCATION_CONTACTS_FAILURE
                    ]
                }
            });
        }
    },
    create: (locationKey, userId) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'location-contact/create',
                    method: 'POST',
                    body: { locationKey: locationKey, userId: userId },
                    types: [
                        types.CREATE_LOCATION_CONTACT_REQUEST,
                        types.CREATE_LOCATION_CONTACT_SUCCESS,
                        types.CREATE_LOCATION_CONTACT_FAILURE
                    ]
                }
            });
        }
    },
    remove: (locationKey, userId) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'location-contact/remove',
                    method: 'POST',
                    body: { locationKey: locationKey, userId: userId },
                    types: [
                        types.REMOVE_LOCATION_CONTACT_REQUEST,
                        types.REMOVE_LOCATION_CONTACT_SUCCESS,
                        types.REMOVE_LOCATION_CONTACT_FAILURE
                    ]
                }
            });
        }
    },
    contactsToImport: (locationKey, targetLocationKey) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'location-contact/contacts-to-import',
                    method: 'POST',
                    body: { locationKey: locationKey, targetLocationKey: targetLocationKey },
                    types: [
                        types.CONTACTS_TO_IMPORT_REQUEST,
                        types.CONTACTS_TO_IMPORT_SUCCESS,
                        types.CONTACTS_TO_IMPORT_FAILURE
                    ]
                }
            });
        }
    },
    import: (locationKey, targetLocationKey) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'location-contact/import',
                    method: 'POST',
                    body: { locationKey: locationKey, targetLocationKey: targetLocationKey },
                    types: [
                        types.IMPORT_CONTACTS_REQUEST,
                        types.IMPORT_CONTACTS_SUCCESS,
                        types.IMPORT_CONTACTS_FAILURE
                    ]
                }
            });
        }
    }
}